<script setup>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import TopoProfileTable from '@/components/topoprofile/TopoProfileTable.vue'
import TopoProfileLineChart from '@/components/topoprofile/TopoProfileLineChart.vue'
import TabTemplate from '@/components/common/TabTemplate.vue'
import { dirtyFieldMixin } from '@/mixins/dirtyFieldMixin'


const store = useStore()
const { addDirty, dirtyItems } = dirtyFieldMixin()

const currentDikeSectionId = computed(() => store.getters['dikeSection/getDikeSectionId'])
const dikeProfilesElevation = computed(() => store.state.dikeProfiles.dikeProfilesElevation)

const currentDikeProfilesElevation = computed(() => {
  return currentDikeSectionId.value
    ? dikeProfilesElevation.value.filter(
        (item) => item.properties.dikesection_id === currentDikeSectionId.value
      )
    : null
})

const fetchDikeProfilesElevation = (...args) =>
  store.dispatch('dikeProfiles/fetchDikeProfilesElevation', ...args)

watch(currentDikeSectionId, (value) => {
  if (value) {
    fetchDikeProfilesElevation(value)
  }
})
</script>

<template>
  <TabTemplate class="fill-height">
    <template v-slot:chart>
      <TopoProfileLineChart
      :dike-profiles="currentDikeProfilesElevation"
      ref="chart"
      @add-dirty="addDirty" 
      />
    </template>
    <template v-slot:content>
      <TopoProfileTable
        :dirty-items="dirtyItems"
        @add-dirty="addDirty" 
        @empty-dirty="dirtyItems = []"
      />
    </template>
  </TabTemplate>
</template>
